module.exports = __webpack_public_path__ + "fa-solid-900.962a1bf31c081691065f.svg";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-solid-900.svg
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-solid-900.svg
// module chunks = styles